import {
  HtmlEditor,
  Image,
  Inject,
  Link,
  QuickToolbar,
  RichTextEditorComponent,
  Toolbar,
} from "@syncfusion/ej2-react-richtexteditor";

import * as React from "react";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-icons/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import "@syncfusion/ej2-splitbuttons/styles/material.css";
import "@syncfusion/ej2-inputs/styles/material.css";
import "@syncfusion/ej2-lists/styles/material.css";
import "@syncfusion/ej2-navigations/styles/material.css";
import "@syncfusion/ej2-popups/styles/material.css";
import "@syncfusion/ej2-richtexteditor/styles/material.css";
import "./editorTheme.css";
const CustomRichTextEditor: React.FC<any> = (props) => {
  const toolbarSettings = {
    items: [
      "Bold",
      "Italic",
      "|",
      "OrderedList",
      "UnorderedList",
      "|",
      "CreateLink",
      "RemoveLink",
      "|",
      "Undo",
      "Redo",
    ],
  };

  return (
    <RichTextEditorComponent
      // @ts-ignore
      EditorMode={"EditorMode.Markdown"}
      height={300}
      toolbarSettings={toolbarSettings}
      change={(e: any) => {
        props.change(e.value);
      }}
      value={props.value}
    >
      <Inject services={[Toolbar, Image, Link, HtmlEditor, QuickToolbar]} />
    </RichTextEditorComponent>
  );
};
export default CustomRichTextEditor;
